<script lang="ts" setup>

  import { useI18n } from 'vue-i18n'

  const route = useRoute()

  const { t } = useI18n()
  const isExploreActive = computed(() => {
    const names = ['index', 'search']
    return names.includes(route.name as string)
  })

  const isDisplayed = computed(() => {
    const displayedNames = ['index', 'search', 'favorites', 'reservations', 'reservation-detail']
    if (!route.name) {
      return false
    }
    return displayedNames.includes(route.name as string)
  })

</script>

<template>
  <div
    v-if="isDisplayed"
    class="c-mobile-nav-footer"
  >
    <NuxtLink
      to="/"
      class="nav-link"
      :class="{ 'router-link-exact-active': isExploreActive }"
    >
      <SvgIcon
        icon="explorer"
        :width="20"
        :height="20"
      />
      <span class="label">{{ t("navigation.explore") }}</span>
    </NuxtLink>
    <NuxtLink
      to="/favorites"
      class="nav-link favorites"
    >
      <SvgIcon
        icon="favoris"
        :width="20"
        :height="20"
      />
      <span class="label">{{ t("navigation.favorites") }}</span>
    </NuxtLink>
    <NuxtLink
      to="/reservations"
      class="nav-link reservations"
    >
      <SvgIcon
        icon="reservations"
        :width="20"
        :height="20"
      />
      <span class="label">{{ t("navigation.reservations") }}</span>
    </NuxtLink>
  </div>
</template>
<style scoped>
.c-mobile-nav-footer {
  position: fixed;
  z-index: 10;
  right: 0;
  bottom: env(safe-area-inset-bottom);
  left: 0;
  display: flex;
  height: 55px;
  flex: 0 0 auto;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  background-color: white;
  box-shadow: var(--box-shadow-1);

  &::after {
    position: absolute;
    right: 0;
    bottom: calc(-1 * (env(safe-area-inset-bottom)));
    left: 0;
    height: env(safe-area-inset-bottom);
    background-color: #fff;
    content: "";
  }

  .nav-link {
    display: flex;
    width: 20%;
    flex-direction: column;
    align-items: center;
    opacity: 0.3;

    .c-icon {
      color: var(--color-secondary);
    }

    .label {
      margin-top: 0.125em;
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 14px;
    }

    &.router-link-exact-active,
    &.favorites.router-link-active,
    &.reservations.router-link-active {
      opacity: 1;

      .c-icon {
        color: var(--color-primary);
      }

      .label {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 14px;
        font-weight: 700;
      }
    }
  }

  @media all and (width >= 1024px) {
    display: none;
  }
}
</style>
